import BaseComponent from './BaseComponent';
//import Rails         from 'rails-ujs';

class InputRadio extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }

  init(component) {
    this.addCustomEvents(component);
  }
  
  addCustomEvents(component) {
    const submitOnChange = component.element.getAttribute('data-submit-on-change') == 'true';
    if (submitOnChange) {

      component.element.addEventListener('change', () => {
        const form = component.element.form;
        form.removeAttribute('data-remote');
        form.submit();
      });
    } 
  }
}

export default InputRadio;
